import React, { useEffect, useState } from 'react';
import api from '../../api/client';
import Button from '../../components/Button';
import FormField, { Input, Textarea } from '../../components/FormField';

export default function AdminInfo() {
  const [entries, setEntries] = useState([]);
  const [editing, setEditing] = useState(null);
  const [form, setForm]       = useState({ title: '', content: '', sort_order: 0 });
  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState('');

  const load = () => {
    api.get('/api/info').then((r) => setEntries(r.data));
  };
  useEffect(() => { load(); }, []);

  const set = (f) => (e) => setForm({ ...form, [f]: e.target.value });

  const openNew = () => {
    setForm({ title: '', content: '', sort_order: entries.length });
    setEditing('new'); setError('');
  };

  const openEdit = (entry) => {
    setForm({ title: entry.title, content: entry.content, sort_order: entry.sort_order });
    setEditing(entry.id); setError('');
  };

  const save = async (e) => {
    e.preventDefault();
    setLoading(true); setError('');
    try {
      const payload = { title: form.title, content: form.content, sort_order: Number(form.sort_order) || 0 };
      if (editing === 'new') {
        await api.post('/api/admin/info', payload);
      } else {
        await api.put(`/api/admin/info/${editing}`, payload);
      }
      setEditing(null); load();
    } catch (err) {
      setError(err.response?.data?.detail || 'Fehler beim Speichern');
    } finally { setLoading(false); }
  };

  const deleteEntry = async (id) => {
    if (!window.confirm('Info wirklich löschen?')) return;
    await api.delete(`/api/admin/info/${id}`);
    load();
  };

  return (
    <div>
      <h2 className="page-title">Infos</h2>
      <p className="text-sm text-slate-500 mb-6 max-w-2xl">
        Diese Hinweise werden auf der Info-Anzeige (Beamer/TV) angezeigt — z.B. Netzwerkeinstellungen,
        IP-Adressen von TeamSpeak- oder FTP-Server, oder andere wichtige Ansagen.
      </p>

      <div className="flex justify-between items-center mb-4">
        <p className="text-sm text-slate-500">{entries.length} Info(s)</p>
        <Button onClick={openNew} size="sm">+ Info hinzufügen</Button>
      </div>

      {editing && (
        <div className="card border border-ocean-200 mb-6">
          <h3 className="section-title">{editing === 'new' ? 'Neue Info' : 'Info bearbeiten'}</h3>
          {error && <div className="alert-error mb-4">{error}</div>}
          <form onSubmit={save}>
            <FormField label="Titel" required>
              <Input value={form.title} onChange={set('title')} placeholder="z.B. Netzwerk" required />
            </FormField>
            <FormField label="Inhalt" required hint="Zeilenumbrüche werden auf der Anzeige übernommen.">
              <Textarea value={form.content} onChange={set('content')} rows={5}
                placeholder={'Nur DHCP verwenden, keine statischen IPs.\nTeamSpeak: 10.0.0.10\nFTP: 10.0.0.20'} required />
            </FormField>
            <FormField label="Reihenfolge">
              <Input type="number" value={form.sort_order} onChange={set('sort_order')} className="w-24" />
            </FormField>

            <div className="flex gap-2">
              <Button type="submit" loading={loading}>Speichern</Button>
              <Button variant="ghost" type="button" onClick={() => setEditing(null)}>Abbrechen</Button>
            </div>
          </form>
        </div>
      )}

      {entries.length === 0 && !editing ? (
        <div className="card text-center py-8 text-slate-400 text-sm">Noch keine Infos vorhanden.</div>
      ) : (
        <div className="space-y-3">
          {entries.map((entry) => (
            <div key={entry.id} className="card flex items-start gap-4">
              <div className="flex-1 min-w-0">
                <p className="font-bold text-ocean-900">{entry.title}</p>
                <p className="text-sm text-slate-500 whitespace-pre-line mt-1">{entry.content}</p>
                <p className="text-xs text-slate-400 mt-2">Reihenfolge: {entry.sort_order}</p>
              </div>
              <div className="flex gap-2 flex-shrink-0">
                <Button variant="secondary" size="sm" onClick={() => openEdit(entry)}>Bearbeiten</Button>
                <Button variant="danger" size="sm" onClick={() => deleteEntry(entry.id)}>Löschen</Button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
